export default __webpack_public_path__ + "static/media/Fustat-SemiBold.f65a8694.ttf";